__turbopack_context__.v({
  "active": "PillButtons-module-scss-module__j22PNG__active",
  "bottomLabel": "PillButtons-module-scss-module__j22PNG__bottomLabel",
  "fullWidth": "PillButtons-module-scss-module__j22PNG__fullWidth",
  "mobileFullWidth": "PillButtons-module-scss-module__j22PNG__mobileFullWidth",
  "pillButtonWrap": "PillButtons-module-scss-module__j22PNG__pillButtonWrap",
  "pillButtons": "PillButtons-module-scss-module__j22PNG__pillButtons",
});
